import { FileAddOutlined } from '@ant-design/icons'
import type { BaseFreightGroup } from '@/api/useFreight/types'
import { GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Popover, Tooltip } from 'antd'
import React from 'react'
import { ScheduleNewRateForm } from './ScheduleNewRateForm'
import type { BaseFreightRate } from '../../../../../../../api/useFreight/types'
import type { CreateRateFormValues } from '../hooks/useMileageBandDetails'

interface RatebookHeaderProps {
  selectedGroup: BaseFreightGroup
  isEditMode: boolean
  isCreatePopoverOpen: boolean
  setIsCreatePopoverOpen: (isOpen: boolean) => void
  handleCreateRate: (values: CreateRateFormValues) => Promise<void>
  sortedHistory: BaseFreightRate[]
}

export function RatebookHeader({
  selectedGroup,
  isEditMode,
  isCreatePopoverOpen,
  setIsCreatePopoverOpen,
  handleCreateRate,
  sortedHistory,
}: RatebookHeaderProps) {
  return (
    <Vertical
      flex='0'
      style={{ overflow: 'visible' }}
      border='all'
      borderRadius='4px'
      bg='elevated'
      className='p-4'
      gap={16}
    >
      <Horizontal className='pb-3' border='bottom' justifyContent='space-between'>
        <Texto
          category='h5'
          style={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
          }}
          weight='600'
        >
          {selectedGroup.freight_region_name ? `${selectedGroup.freight_region_name} Base Rates` : 'Global Base Rates'}
        </Texto>
        {!isEditMode && (
          <Tooltip title='Schedule New Rate'>
            <Popover
              open={isCreatePopoverOpen}
              onOpenChange={setIsCreatePopoverOpen}
              trigger='click'
              title='Schedule New Rate'
              content={
                <ScheduleNewRateForm
                  sortedHistory={sortedHistory}
                  onSubmit={(values) => {
                    return handleCreateRate(values)
                  }}
                  closePopover={() => setIsCreatePopoverOpen(false)}
                />
              }
              placement='topRight'
              arrow
            >
              <GraviButton buttonText='Schedule New Rate Table' theme2 icon={<FileAddOutlined />} />
            </Popover>
          </Tooltip>
        )}
      </Horizontal>

      <Horizontal justifyContent='space-between'>
        <Horizontal gap={32}>
          <Horizontal gap={8}>
            <Texto appearance='hint'>Region</Texto>
            <Texto>{selectedGroup.freight_region_name || 'Any'}</Texto>
          </Horizontal>
          <Horizontal gap={8}>
            <Texto appearance='hint'>Product</Texto>
            <Texto>{selectedGroup.product_group || 'Any'}</Texto>
          </Horizontal>
        </Horizontal>
      </Horizontal>
    </Vertical>
  )
}
